import { useFeatureFlagEnabled } from "posthog-js/react";
import { IS_DEVELOPMENT } from "@/lib/constants";
import { FEATURE_FLAGS } from "./";
import { FeatureFlagsContext } from "./context";

export function FeatureFlagProvider(
	props: Omit<React.ComponentProps<typeof FeatureFlagsContext.Provider>, "value">,
) {
	const isDevelopment = useFeatureFlagEnabled(FEATURE_FLAGS.isDevelopment.key);
	const canRefineCoreValue = useFeatureFlagEnabled(FEATURE_FLAGS.canRefineCoreValue.key);
	const canSeePerfectDayMenuItem = useFeatureFlagEnabled(
		FEATURE_FLAGS.canSeePerfectDayMenuItem.key,
	);
	const canShare = useFeatureFlagEnabled(FEATURE_FLAGS.canShare.key);

	return (
		<FeatureFlagsContext.Provider
			{...props}
			value={{
				isDevelopment: IS_DEVELOPMENT || !!isDevelopment,
				canRefineCoreValue,
				canSeePerfectDayMenuItem: IS_DEVELOPMENT || canSeePerfectDayMenuItem,
				canShare,
			}}
		/>
	);
}
